import { render } from "./etBtnDelMini.vue?vue&type=template&id=1a590923"
import script from "./etBtnDelMini.vue?vue&type=script&lang=js"
export * from "./etBtnDelMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__